// extracted by mini-css-extract-plugin
module.exports = {"pointer":"app_pointer__3P8TN","app":"app_app__3Pz62","head":"app_head__1Qefh","main":"app_main__TFLza"};